export const clothingEpicFilterOptions = {
  epicCategories: {
    displayName: "Categories",
    values: [
      {
        displayName: "Dresses",
        id: "dress",
      },
      {
        displayName: "Gowns",
        id: "gowns",
      },
      {
        displayName: "Jumpsuits & Rompers",
        id: "jumpsuitsandrompers",
      },
      {
        displayName: "Tops",
        id: "tops",
      },
      {
        displayName: "Knits",
        id: "knits",
      },
      {
        displayName: "Pants",
        id: "pants",
      },
      {
        displayName: "Jeans",
        id: "jeans",
      },
      {
        displayName: "Shorts",
        id: "shorts",
      },
      {
        displayName: "Skirts",
        id: "skirts",
      },
      {
        displayName: "Jackets & Coats",
        id: "outerwear",
      },
      {
        displayName: "Blazers",
        id: "blazer",
      },
    ],
  },
};

export default clothingEpicFilterOptions;
export const { epicCategories, epicSeasonality } = clothingEpicFilterOptions;
